export default __webpack_public_path__ + "static/media/calendar-icon.57482404.svg";